/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Hostpublishdescription2Inputs */

const en_hostpublishdescription2 = /** @type {(inputs: Hostpublishdescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} isn't public yet. A public event needs a public profile.`)
};

const de_hostpublishdescription2 = /** @type {(inputs: Hostpublishdescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ist noch nicht öffentlich. Ein öffentliches Event braucht ein öffentliches Profil.`)
};

/**
* | output |
* | --- |
* | "{name} isn't public yet. A public event needs a public profile." |
*
* @param {Hostpublishdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const hostpublishdescription2 = /** @type {((inputs: Hostpublishdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hostpublishdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hostpublishdescription2(inputs)
	return de_hostpublishdescription2(inputs)
});
export { hostpublishdescription2 as "hostPublishDescription" }